<template>
   <v-container class="ma-auto">
    <v-row class="mb-3" no-gutters v-if="$vuetify.breakpoint.mdAndUp"><h1 class="header font-weight-bold" v-if="$vuetify.breakpoint.mdAndUp">{{ $t('signup.header') }}</h1></v-row>
    <v-row :class="{'mainBorder': $vuetify.breakpoint.mdAndUp}" no-gutters>
      <v-col class="primary white--text pb-8" cols="4" style="position: relative" v-if="$vuetify.breakpoint.mdAndUp">
        <div class="d-flex flex-column align-center justify-center fill-height">
          <div>
          <span class="text-h6">{{ $t('signup.motivation_title') }}</span><br/>
          <div class="text-subtitle-2 d-block mt-4"><v-icon color="white" class="mr-2">check</v-icon><span class="oneStepText">{{ $t('signup.motivation_item1') }}</span></div>
          <div class="text-subtitle-2 d-block mt-2"><v-icon color="white" class="mr-2">check</v-icon><span class="oneStepText">{{ $t('signup.motivation_item2') }}</span></div>
          <div class="text-subtitle-2 d-block mt-2"><v-icon color="white" class="mr-2">check</v-icon><span class="oneStepText">{{ $t('signup.motivation_item3') }}</span></div>
          </div>
        </div>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 8 : 12" class="pt-0 pr-0">
        <r-form-card class="white">
          <div class="text-center">
            <img src="static/images/vevox-logo.svg" class="logo" v-if="$vuetify.breakpoint.smAndDown"/>
          </div>
          <div class="stepperHeader d-flex align-center my-3 my-sm-4">
            <div class="stepNumber rounded-xl secondary white--text">
              <v-icon color="white" class="stepIcon mt-1" small>check</v-icon>
            </div>
            <span class="secondary--text ml-2 font-weight-bold">{{ $t('signup.step1_header') }}</span>
            <hr class="secondary mx-2 flex-grow-1" />
            <div class="stepNumber rounded-xl secondary white--text font-weight-medium" style="padding-top: 2px">
              2
            </div>
            <span class="secondary--text ml-2 font-weight-bold">{{ $t('signup.step2_header') }}</span>
          </div>
          <v-progress-circular v-if="secondStepInfo == null" indeterminate color="primary"/>
          <v-form v-if="secondStepInfo != null" ref="signupform" v-model="valid" lazy-validation>
            <h2 class="mb-2 text-h6">{{ $t("setup_account") }}</h2>
            <v-alert :value="error.length > 0" dense text type="error" data-testid="v-alert_6a4a26a0-ae12-4091-b362-a94ae3bb977a">
              {{error}}
            </v-alert>
            <!--<r-form-text-field :disabled="true" v-model="secondStepInfo.email" :rules="[]" v-bind:label="$t('email')" data-testid="email-input"></r-form-text-field>-->
            <div v-if="secondStepInfo.hasProfile === false" class="d-flex">
              <r-form-text-field class="flex-grow-1 mr-4" v-model="firstName" :rules="requiredRules" maxlength="40" v-bind:label="$t('first_name')" data-testid="firstname-input"></r-form-text-field>
              <r-form-text-field class="flex-grow-1 ml-4" v-model="lastName" :rules="requiredRules" maxlength="40" v-bind:label="$t('last_name')" data-testid="lastname-input"></r-form-text-field>
            </div>
            <div class="text-body-1">{{ $t('i_want_to_use_vevox_for') }}</div>
            <v-radio-group v-model="accountType" row class="mt-0">
              <v-radio :label="$t('business')" value="business"/>
              <v-radio :label="$t('education')" value="education"/>
            </v-radio-group>
          <v-text-field outlined dense v-model="accountName" :rules="accountNameRules" @focusout.native="accountNameFocusOut()"
            v-bind:label="accountNameLabel" data-testid="accountname-input" counter="30"></v-text-field>
            <!--<div class="d-flex align-center">
              <r-form-text-field v-model="tenancyUrlPrefix" class="flex-grow-1" :error-messages="tenancyUrlErrors" @input="validateTenancyUrl" :loading="tenancyUrlIsValidating" :label="$t('your_unique_dashboard_url')" data-testid="dashboardurl-input"></r-form-text-field>
              <div class="text-subtitle-1">
                .{{ secondStepInfo.topDomain }}
              </div>
            </div>-->
            <v-text-field outlined dense v-model="jobTitle" :rules="requiredRules" v-bind:label="$t('job_title')" data-testid="jobtitle-input"></v-text-field>
            <v-autocomplete outlined dense :items="filteredCountries" item-text="countryName" item-value="countryCode" v-model="country" :rules="requiredRules"
              :label="$t('country')" data-testid="country-select" @change="countryChanged($event)"></v-autocomplete>
            <v-text-field outlined dense v-model="phone" :rules="requiredRules" v-bind:label="$t('phone_number')" data-testid="phone-input" ref="phoneinput" persistent-placeholder></v-text-field>
            <v-checkbox v-model="emailOptIn" class="mt-0"  hide-details>
              <template v-slot:label>
                <div>
                  <span>{{ $t("signup.email_opt_in") }}</span>
                </div>
              </template>
            </v-checkbox>
            <div class="buttondiv my-4 my-md-6">
              <!-- ID is used for tracking, do not change! -->
              <r-form-submit-button id="signup_complete_account_setup" :loading="signupInProgress" :disabled="!valid || tenancyUrlIsValidating" v-on:click="completeSignup" data-testid="complete-button">{{ $t("complete_account_setup") }}</r-form-submit-button>
            </div>
          </v-form>
          <div class="text-body-1 footer">
            {{ $t('need_some_help') }} <a href="https://www.vevox.com/contact" target="_blank" data-testid="a_b993c14b-e86d-4ff0-accf-c56f6e58c2b3">{{ $t('contact_us') }}</a>
          </div>
        </r-form-card>
       </v-col>
    </v-row>
    <v-row class="mt-2 d-flex justify-space-around" v-if="$vuetify.breakpoint.mdAndUp">
      <img src="static/images/vevox/signup_G2_badge.png" class="mx-4 signupBadgeLarge"/>
      <img src="static/images/vevox/signup_trustpilot_badge.png" class="mx-4 signupBadge"/>
      <img src="static/images/vevox/signup_capterra.png" class="mx-4 signupBadge"/>
    </v-row>
  </v-container>
</template>

<script>
import { dashboardUserService } from 'reactor-js-core/dist/services/dashboarduserservice.js'
import { signupService } from 'reactor-js-core/dist/services/signupservice.js'
import utils from 'reactor-js-core/dist/utils.js'
import { persistentStorage } from 'reactor-js-core/dist/persistentstorage.js'
import analytics from '@/analytics';
import cookieconsent from '@/js/cookieconsent'
import TrustpilotWidget from './TrustpilotWidget.vue'
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';

export default {
  name: 'SetupAccount',
  components: {
    TrustpilotWidget
  },
  data () {
    return {
      valid: false,
      error: '',
      firstName: '',
      lastName: '',
      requiredRules: [
        value => {
          if (value == null || value.trim().length == 0) return this.$t('required');
          return true;
        }
      ],
      accountNameRules: [
        value => {
          if (value == null || value.trim().length == 0) return this.$t('required');
          if (value.trim().length > 30) return this.$t('signup.name_too_long');
          return true;
        }
      ],
      accountName: '',
      tenancyUrlPrefix: '',
      tenancyUrlErrors: null,
      tenancyUrlIsValidating: false,
      tenancyUrlGracePeriod: null,
      jobTitle: '',
      phone: '',
      country: null,
      accountType: 'business',
      secondStepInfo: null,
      signupInProgress: false,
      emailOptIn: false,
      filteredCountries: null,
      countryCodesToRemove: [
        "CU",
        "IR",
        "KP",
        "RU",
        "SY"
      ],
      iti: null,
      educationUrls: [
        ".edu",
        ".ac"
      ]
    }
  },
  computed: {
    accountNameLabel() {
      return this.$t('account_name_' + this.accountType);
    },
    tenancyUrl() {
      if (this.secondStepInfo == null || this.tenancyUrlPrefix == null) return null;
      return this.tenancyUrlPrefix.trim() + "." + this.secondStepInfo.topDomain;
    },
    fullPhoneNumber() {
      return "+" + this.iti.getSelectedCountryData().dialCode + this.phone;
    },
    mobileBreakPoint() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    accountNameFocusOut() {
      if (this.tenancyUrlPrefix === '') {
        this.tenancyUrlPrefix = this.accountName.toLowerCase().replace(/[^a-z0-9_-]+/g, "");
        this.validateTenancyUrl();
      }
    },
    setError(error) {
      this.error = error;
    },
    completeSignup: function (event) {
      this.setError('');
      if (this.$refs.signupform.validate()) {
        var req = {
          appId: this.$root.appId(),
          isEducation: (this.accountType === "education"),
          phone: this.fullPhoneNumber,
          countryCode: this.country,
          name: this.accountName,
          url: this.tenancyUrl,
          token: this.$route.params.id,
          invitationId: persistentStorage.get("invitationId"),
          jobTitle: this.jobTitle.trim(),
          emailOptIn: this.emailOptIn
        }
        if (this.secondStepInfo.hasProfile === false) {
          req.firstName = this.firstName.trim();
          req.lastName = this.lastName.trim();
        }

        var csrf_token = utils.uuidv4();
        persistentStorage.set("loginCSRFToken", csrf_token);
        this.signupInProgress = true;

        analytics.pushVirtualPageview('/signup-form/step-2', 'Sign up form step 2');
        analytics.pushEvent('GetStarted');

        signupService.finalizeSignupSecondStep(req).then((response) => {
          var reactordashboard_tenancy = "https://" + response.tenancyUrl + "/";
          persistentStorage.set("loginTenancyUrl", reactordashboard_tenancy);
          persistentStorage.set("loginToken", this.$route.params.id);
          var hash_index = window.location.href.indexOf("#");
          var verification_url = window.location.href.substring(0, hash_index);
          var url_to_navigate_to = reactordashboard_tenancy + "#/tokenlogin?login_verification_url=" + encodeURIComponent(verification_url + "#/tokenlogin?login_csrf_token=" + persistentStorage.get("loginCSRFToken")) + cookieconsent.getConsentTransferParameter();

          window.location.href = url_to_navigate_to;
        }, (failure) => {
          this.signupInProgress = false;
          this.setError("Signup failed");
        });
      }
    },
    validateTenancyUrl() {
      if (this.tenancyUrlIsValidating && this.tenancyUrlGracePeriod == null) return;

      this.tenancyUrlIsValidating = true;

      if (this.tenancyUrlGracePeriod != null) clearTimeout(this.tenancyUrlGracePeriod);

      this.tenancyUrlGracePeriod = setTimeout(() => {
        this.tenancyUrlGracePeriod = null;
        var tenancy_url = this.tenancyUrl;
        signupService.validateUniqueTenancyURL({url: tenancy_url}).then((response) => {
          if (response.status) {
            this.tenancyUrlErrors = null;
          }
          else {
            this.tenancyUrlErrors = this.$t('signup_url_invalid');
          }
        }, (failure) => {
          this.tenancyUrlErrors = this.$t('signup_url_invalid');
        }).finally(() => {
          this.tenancyUrlIsValidating = false;
          if (this.tenancyUrl != tenancy_url) {
            //tenancy url changed while we were validating
            this.validateTenancyUrl();
          }
        });
      }, 1000);
    },
    countryChanged(country_code) {
      this.iti.setCountry(country_code);
    }
  },
  mounted() {
    if (this.$route.query.activation_code != null) {
      //the signup reminder e-mail sends out an activation code (which actullly is an invitation ID)
      //this is used to skip the verification e-mail if the user is already coming from an e-mail
      persistentStorage.set("invitationId", this.$route.query.activation_code);
    }
    if (this.$route.query.region_url != null) {
      this.$root.connectToRegion(this.$route.query.region_url);
    }
    var login_id = this.$route.params.id;
    signupService.startShortSignupSecondStep({appId: this.$root.appId(), loginToken: login_id}).then((response) => {
      if (response.secondStepInfo != null) {
        this.secondStepInfo = response.secondStepInfo;
        if (response.secondStepInfo.countryInfo) {
          this.country = response.secondStepInfo.countryInfo.countryCode;
        }
        this.filteredCountries = this.secondStepInfo.signupCountries;
        this.filteredCountries.forEach(country => {
          if (this.countryCodesToRemove.includes(country.countryCode)) {
            this.filteredCountries.splice(this.filteredCountries.indexOf(country), 1)
          }
        });
        //configure telephone input
        this.$nextTick(() => {
          let country_data = window.intlTelInputGlobals.getCountryData();
          country_data.forEach(country => {
            if (this.countryCodesToRemove.includes(country.iso2.toUpperCase())) {
              country_data.splice(country_data.indexOf(country), 1)
            }
          });
          let phone_input = this.$refs.phoneinput.$el.querySelector(".v-text-field__slot input");
          this.iti = intlTelInput(phone_input, {
            initialCountry: this.country,
            separateDialCode: true
        });

        if (this.secondStepInfo.email != null) {
          let email_suffix = this.secondStepInfo.email.substring(this.secondStepInfo.email.indexOf('@') + 1, this.secondStepInfo.email.length)
          this.educationUrls.forEach(url => {
            if (email_suffix.includes(url)) {
              this.accountType = "education";
            }
          });
        }
    });
      }
      else {
        this.$log.error("Could not start short signup, login token might have expired");
        this.$router.push({ name: 'CreateAccount' });
      }
    }, (failure) => {
      this.$log.error("Could not start short signup");
      this.$router.push({ name: 'CreateAccount' });
    });
  },
  watch: {
     mobileBreakPoint() {
        //reinitialize phone input on breakpoint change (does not work otherwise)
        this.$nextTick(() => {
          let selected_dial_code = this.iti.getSelectedCountryData().iso2;
          this.iti.destroy();
          let phone_input = this.$refs.phoneinput.$el.querySelector(".v-text-field__slot input");
          this.iti = intlTelInput(phone_input, {
            initialCountry: selected_dial_code,
            separateDialCode: true
          });
        });
     }
  }
}
</script>

<style scoped lang="scss">
.mainBorder {
  border: 1px solid #e0e0e0;
}
.stepperHeader {
  max-width: 320px;
}

.stepNumber {
  width: 24px;
  height: 24px;
  text-align: center;
  font-size: 0.8rem;
}

.stepIcon {
  vertical-align: baseline;
}

.logo {
  width: 160px;
}

.header {
  font-size: 1.7rem;
}

.footer {
  margin-top: 32px;
  margin-bottom: 16px;
}

.signupBadge {
  height: 80px;
  margin-top: 12px;
  width: auto;
}

.signupBadgeLarge {
  height: 128px;
  width: auto;
}

.oneStepText {
  vertical-align: bottom;
}

.buttondiv {
  text-align: center;
}

@media only screen and (max-height: 800px)  {
  .header {
    font-size: 1.6rem;
  }

  .footer {
    margin-top: 16px;
    margin-bottom: 0px;
  }
  .signupBadge {
    height: 50px;
    margin-top: 10px;
    width: auto;
  }
  .signupBadgeLink {
    width: 150px;
  }
  .signupBadgeLarge {
    height: 90px;
    width: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/signup/SetupAccount.vue